import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, remove } from 'kapix-components-vue3'
import blocArgCtaRdvPedagogieMatchersComponentStoreCustom from './store.custom'

const storeName = 'blocArgCtaRdvPedagogieMatchersComponent'
const customImplement: CustomStoreImplementationOptions = blocArgCtaRdvPedagogieMatchersComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function blocArgCtaRdvPedagogieMatchersComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          expert1: undefined as Nullable<string | File>,
          expert2: undefined as Nullable<string | File>,
          expert3: undefined as Nullable<string | File>,
          titreExperts: undefined as Nullable<string>
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $expert1 (): WritableComputedRef<Nullable<string | File>> {
        return computed({
          get: () => this.$data.expert1,
          set: (value) => {
            this.$data.expert1 = value
            this.$emit('update:expert1', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $expert2 (): WritableComputedRef<Nullable<string | File>> {
        return computed({
          get: () => this.$data.expert2,
          set: (value) => {
            this.$data.expert2 = value
            this.$emit('update:expert2', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $expert3 (): WritableComputedRef<Nullable<string | File>> {
        return computed({
          get: () => this.$data.expert3,
          set: (value) => {
            this.$data.expert3 = value
            this.$emit('update:expert3', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $titreExperts (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.titreExperts,
          set: (value) => {
            this.$data.titreExperts = value
            this.$emit('update:titreExperts', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return blocArgCtaRdvPedagogieMatchersComponentFactory(storeId)()
}

export const blocArgCtaRdvPedagogieMatchersComponentRaw = blocArgCtaRdvPedagogieMatchersComponentFactory()
export const blocArgCtaRdvPedagogieMatchersComponent = () => blocArgCtaRdvPedagogieMatchersComponentRaw() as MergeCustomStore<typeof blocArgCtaRdvPedagogieMatchersComponentStoreCustom.instance>
